import React, { useEffect, useState } from "react";
import Footer from "../footer";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { CreateMarketingSchool } from "../../../api/MarketinService";
import { useLocation, useNavigate } from "react-router-dom";
import { subjectList } from "../../../api/Subjects";
import {
  BlockFetch,
  DistrictFetch,
  StateFetch,
} from "../../../api/LocationService";
import { getSessions } from "../../../api/SessionsService";
import { SweetAlertShow } from "../../master/Master";
import MarketingHeader from "./MarketingHeader";

const AddMarketingSchool = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [school, setSchool] = useState([]);
  const location = useLocation();

  const [HostelId, setHostelId] = useState("");
  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allBlock, setAllBlock] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");

  const [subjects, setSubjects] = useState("");
  const [session, setSession] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedSource, setSelectedSource] = useState("");

  const navigate = useNavigate();

  /* =========================================================
     CREATE SOURCE
  ========================================================= */

  const createSource = async (e) => {
    e.preventDefault();

    if (loading) return;

    setError("");

    const form = e.target;

    const sourceName = form.source_name?.value?.trim();
    const contactPerson = form.contact_person?.value?.trim();
    const contactNo = form.contact_no?.value?.trim();
    const email = form.email?.value?.trim();
    const sourceType = form.source_type?.value;
    const sessionId = form.session_id?.value;

    const requiresLocation = ["School", "Coaching", "College"].includes(
      sourceType,
    );

    const village = form.village?.value?.trim();
    const state = form.state?.value;
    const district = form.district?.value;
    const pincode = form.pincode?.value?.trim();

    /* =========================================================
       FRONTEND VALIDATION
    ========================================================= */

    if (!sessionId) {
      setError({
        session_id: "Please select a session.",
      });
      return;
    }

    if (!sourceName) {
      setError({
        source_name: "Source name is required.",
      });
      return;
    }

    if (sourceName.length < 2) {
      setError({
        source_name: "Source name must contain at least 2 characters.",
      });
      return;
    }

    if (!contactPerson) {
      setError({
        contact_person: "Contact person is required.",
      });
      return;
    }

    if (contactPerson.length < 2) {
      setError({
        contact_person: "Contact person must contain at least 2 characters.",
      });
      return;
    }

    if (!contactNo) {
      setError({
        contact_no: "Contact number is required.",
      });
      return;
    }

    if (!/^[0-9]{10}$/.test(contactNo)) {
      setError({
        contact_no: "Contact number must contain exactly 10 digits.",
      });
      return;
    }

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError({
        email: "Please enter a valid email address.",
      });
      return;
    }

    if (!sourceType) {
      setError({
        source_type: "Please select source type.",
      });
      return;
    }

    if (requiresLocation) {
      if (!village) {
        setError({
          village: "Village is required.",
        });
        return;
      }

      if (!state) {
        setError({
          state: "Please select a state.",
        });
        return;
      }

      if (!district) {
        setError({
          district: "Please select a district.",
        });
        return;
      }

      if (!pincode) {
        setError({
          pincode: "Pincode is required.",
        });
        return;
      }

      if (!/^[0-9]{6}$/.test(pincode)) {
        setError({
          pincode: "Pincode must contain exactly 6 digits.",
        });
        return;
      }
    }

    setLoading(true);

    try {
      const formData = new FormData(form);

      const response = await CreateMarketingSchool(formData);

      if (response?.data?.status) {
        setError("");

        navigate("/marketing");
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Something went wrong.",
        );
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.message ??
          "Something went wrong.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GET STATES
  ========================================================= */

  const getState = async () => {
    setLoading(true);

    try {
      const response = await StateFetch();

      if (response?.data) {
        setError("");
        setAllStates(response?.data?.states || []);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to fetch states.",
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to fetch states.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GET DISTRICTS
  ========================================================= */

  const getdistrict = async (state) => {
    if (!state) {
      setAllDistricts([]);
      return;
    }

    setLoading(true);

    try {
      const response = await DistrictFetch(state);

      if (response?.data) {
        setAllDistricts(response?.data?.districts || []);
      } else {
        setAllDistricts([]);

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "No districts found.",
        );
      }
    } catch (err) {
      setAllDistricts([]);

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to fetch districts.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GET BLOCKS
  ========================================================= */

  const getblock = async (district) => {
    if (!district) {
      setAllBlock([]);
      return;
    }

    setLoading(true);

    try {
      const response = await BlockFetch(district);

      if (response?.data) {
        setAllBlock(response?.data?.blocks || []);
      } else {
        setAllBlock([]);
      }
    } catch (err) {
      setAllBlock([]);

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to fetch blocks.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GET SUBJECTS
  ========================================================= */

  const getSubjects = async () => {
    setLoading(true);

    try {
      const response = await subjectList();

      if (response?.data) {
        setSubjects(response?.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to fetch subjects.",
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to fetch subjects.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GET SESSION
  ========================================================= */

  const getSession = async () => {
    try {
      const response = await getSessions();

      if (response?.data?.status) {
        const activeSession = response?.data?.data?.find(
          (s) => s?.status == "1",
        );

        setSelectedSession(activeSession?.id || "");
        setSession(response?.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to fetch sessions.",
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to fetch sessions.",
      );
    }
  };

  /* =========================================================
     INITIAL DATA
  ========================================================= */

  useEffect(() => {
    getSubjects();
    getState();
    getSession();
  }, []);

  /* =========================================================
     ERROR HELPER
  ========================================================= */

  const getError = (field) => {
    if (!error) return "";

    if (typeof error === "string") {
      return "";
    }

    if (Array.isArray(error?.[field])) {
      return error[field][0];
    }

    return error?.[field] || "";
  };

  return (
    <>
      {/* =====================================================
          PAGE LAYOUT
      ====================================================== */}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row g-4">
                  {/* =================================================
                      MARKETING HEADER
                  ================================================== */}

                  <div className="col-12">
                    <MarketingHeader />
                  </div>

                  {/* =================================================
                      MAIN CARD
                  ================================================== */}

                  <div className="col-12">
                    <div className="card border-0 shadow-sm overflow-hidden">
                      {/* =================================================
                          HEADER
                      ================================================== */}

                      <div className="card-header bg-transparent border-bottom px-4 py-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                          <div className="d-flex align-items-center gap-3">
                            {/* Icon */}
                            <div
                              className="rounded-3 bg-primary text-white d-flex align-items-center justify-content-center"
                              style={{
                                width: "48px",
                                height: "48px",
                                minWidth: "48px",
                              }}
                            >
                              <i className="ri-megaphone-line fs-4"></i>
                            </div>

                            {/* Title */}
                            <div>
                              <h4 className="mb-1 fw-bold">
                                Add Marketing Source
                              </h4>

                              <p className="mb-0 text-muted small">
                                Create and configure a new marketing source
                              </p>
                            </div>
                          </div>

                          {/* Back */}
                          <button
                            type="button"
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                            onClick={() => navigate(-1)}
                            disabled={loading}
                          >
                            <i className="ri-arrow-left-line"></i>
                            <span>Back</span>
                          </button>
                        </div>
                      </div>

                      {/* =================================================
                          FORM BODY
                      ================================================== */}

                      <div className="card-body p-4 p-lg-5">
                        <form
                          className="text-capitalize"
                          onSubmit={createSource}
                          noValidate
                        >
                          {/* =================================================
                              BASIC INFORMATION
                          ================================================== */}

                          <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div className="text-primary">
                                <i className="ri-information-line fs-5"></i>
                              </div>

                              <div>
                                <h6 className="fw-bold mb-0">
                                  Basic Information
                                </h6>

                                <small className="text-muted">
                                  Enter the source and contact details
                                </small>
                              </div>
                            </div>

                            <div className="border rounded-3 p-3 p-lg-4">
                              <div className="row g-4">
                                {/* Session */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className={`form-select ${
                                        getError("session_id")
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name="session_id"
                                      value={selectedSession}
                                      onChange={(e) =>
                                        setSelectedSession(e.target.value)
                                      }
                                      required
                                    >
                                      <option value="">Select Session</option>

                                      {session?.data?.map((sess) => (
                                        <option key={sess.id} value={sess.id}>
                                          {sess.session} :{" "}
                                          {sess.status === "1"
                                            ? "Active"
                                            : "Inactive"}
                                        </option>
                                      ))}
                                    </select>

                                    <label>
                                      <i className="ri-calendar-line me-1"></i>
                                      Select Session
                                    </label>
                                  </div>

                                  {getError("session_id") && (
                                    <div className="invalid-feedback d-block">
                                      {getError("session_id")}
                                    </div>
                                  )}
                                </div>

                                {/* Source Name */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className={`form-control text-capitalize input-uppercase ${
                                        getError("source_name")
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name="source_name"
                                      placeholder="Source Name"
                                      minLength={2}
                                      maxLength={150}
                                      required
                                    />

                                    <label>
                                      <i className="ri-price-tag-3-line me-1"></i>
                                      Source Name{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>

                                  {getError("source_name") && (
                                    <div className="text-danger small mt-1">
                                      {getError("source_name")}
                                    </div>
                                  )}
                                </div>

                                {/* Contact Person */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className={`form-control text-capitalize ${
                                        getError("contact_person")
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name="contact_person"
                                      placeholder="Contact Person"
                                      minLength={2}
                                      maxLength={100}
                                      required
                                    />

                                    <label>
                                      <i className="ri-user-line me-1"></i>
                                      Contact Person{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>

                                  {getError("contact_person") && (
                                    <div className="text-danger small mt-1">
                                      {getError("contact_person")}
                                    </div>
                                  )}
                                </div>

                                {/* Contact Number */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="tel"
                                      className={`form-control ${
                                        getError("contact_no")
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name="contact_no"
                                      placeholder="Contact No"
                                      inputMode="numeric"
                                      maxLength={10}
                                      minLength={10}
                                      pattern="[0-9]{10}"
                                      required
                                    />

                                    <label>
                                      <i className="ri-phone-line me-1"></i>
                                      Contact No{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>

                                  <small className="text-muted">
                                    Enter a 10-digit mobile number.
                                  </small>

                                  {getError("contact_no") && (
                                    <div className="text-danger small">
                                      {getError("contact_no")}
                                    </div>
                                  )}
                                </div>

                                {/* Email */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="email"
                                      className={`form-control text-lowercase ${
                                        getError("email") ? "is-invalid" : ""
                                      }`}
                                      name="email"
                                      placeholder="Email"
                                      maxLength={150}
                                    />

                                    <label>
                                      <i className="ri-mail-line me-1"></i>
                                      Email
                                    </label>
                                  </div>

                                  {getError("email") && (
                                    <div className="text-danger small mt-1">
                                      {getError("email")}
                                    </div>
                                  )}
                                </div>

                                {/* Source Type */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className={`form-select text-capitalize ${
                                        getError("source_type")
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name="source_type"
                                      value={selectedSource}
                                      onChange={(e) =>
                                        setSelectedSource(e.target.value)
                                      }
                                      required
                                    >
                                      <option value="">
                                        Select Source Type
                                      </option>

                                      <option value="School">School</option>

                                      <option value="Coaching">Coaching</option>

                                      <option value="College">College</option>

                                      <option value="Other">Person</option>
                                    </select>

                                    <label>
                                      <i className="ri-building-line me-1"></i>
                                      Source Type{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>

                                  {getError("source_type") && (
                                    <div className="text-danger small mt-1">
                                      {getError("source_type")}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              LOCATION INFORMATION
                          ================================================== */}

                          {["School", "Coaching", "College"].includes(
                            selectedSource,
                          ) && (
                            <div className="mb-4">
                              <div className="d-flex align-items-center gap-2 mb-3">
                                <div className="text-primary">
                                  <i className="ri-map-pin-line fs-5"></i>
                                </div>

                                <div>
                                  <h6 className="fw-bold mb-0">
                                    Location Information
                                  </h6>

                                  <small className="text-muted">
                                    Enter the source location details
                                  </small>
                                </div>
                              </div>

                              <div className="border rounded-3 p-3 p-lg-4">
                                <div className="row g-4">
                                  {/* Village */}
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="text"
                                        className={`form-control text-capitalize input-uppercase ${
                                          getError("village")
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        name="village"
                                        placeholder="Village"
                                        minLength={2}
                                        maxLength={100}
                                        required
                                      />

                                      <label>
                                        <i className="ri-map-pin-2-line me-1"></i>
                                        Village{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>

                                    {getError("village") && (
                                      <div className="text-danger small mt-1">
                                        {getError("village")}
                                      </div>
                                    )}
                                  </div>

                                  {/* State */}
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className={`form-select text-capitalize ${
                                          getError("state") ? "is-invalid" : ""
                                        }`}
                                        name="state"
                                        onChange={(e) => {
                                          setSelectedStateId(e.target.value);
                                          setAllDistricts([]);
                                          setAllBlock([]);
                                          getdistrict(e.target.value);
                                        }}
                                        required
                                      >
                                        <option value="">Select State</option>

                                        {allStates?.map((state) => (
                                          <option
                                            key={state.id}
                                            value={state.name}
                                          >
                                            {state.name}
                                          </option>
                                        ))}
                                      </select>

                                      <label>
                                        <i className="ri-map-pin-line me-1"></i>
                                        State{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>

                                    {getError("state") && (
                                      <div className="text-danger small mt-1">
                                        {getError("state")}
                                      </div>
                                    )}
                                  </div>

                                  {/* District */}
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className={`form-select text-capitalize ${
                                          getError("district")
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        name="district"
                                        // onChange={(e) => {
                                        //   setAllBlock([]);
                                        //   getblock(e.target.value);
                                        // }}
                                        required
                                        disabled={!selectedStateId}
                                      >
                                        <option value="">
                                          {selectedStateId
                                            ? "Select District"
                                            : "Select State First"}
                                        </option>

                                        {allDistricts?.map((district) => (
                                          <option
                                            key={district.id}
                                            value={district.name}
                                          >
                                            {district.name}
                                          </option>
                                        ))}
                                      </select>

                                      <label>
                                        <i className="ri-map-pin-line me-1"></i>
                                        District{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>

                                    {getError("district") && (
                                      <div className="text-danger small mt-1">
                                        {getError("district")}
                                      </div>
                                    )}
                                  </div>

                                  {/* Pincode */}
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="text"
                                        className={`form-control ${
                                          getError("pincode")
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        name="pincode"
                                        placeholder="Pincode"
                                        inputMode="numeric"
                                        maxLength={6}
                                        minLength={6}
                                        pattern="[0-9]{6}"
                                        required
                                      />

                                      <label>
                                        <i className="ri-map-pin-2-line me-1"></i>
                                        Pincode{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>

                                    <small className="text-muted">
                                      Enter a 6-digit pincode.
                                    </small>

                                    {getError("pincode") && (
                                      <div className="text-danger small">
                                        {getError("pincode")}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* =================================================
                              NOTES
                          ================================================== */}

                          <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div className="text-primary">
                                <i className="ri-sticky-note-line fs-5"></i>
                              </div>

                              <div>
                                <h6 className="fw-bold mb-0">
                                  Additional Information
                                </h6>

                                <small className="text-muted">
                                  Add any additional notes about this source
                                </small>
                              </div>
                            </div>

                            <div className="border rounded-3 p-3 p-lg-4">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  className={`form-control text-capitalize input-uppercase ${
                                    getError("description") ? "is-invalid" : ""
                                  }`}
                                  name="description"
                                  placeholder="Additional Notes"
                                  rows={3}
                                  style={{ minHeight: "110px" }}
                                  maxLength={1000}
                                ></textarea>

                                <label>
                                  <i className="ri-file-text-line me-1"></i>
                                  Additional Notes
                                </label>
                              </div>

                              <div className="d-flex justify-content-between mt-1">
                                <small className="text-muted">Optional</small>

                                {getError("description") && (
                                  <span className="text-danger small">
                                    {getError("description")}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              FORM FOOTER
                          ================================================== */}

                          <div className="border-top pt-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                              <div className="text-muted small">
                                <i className="ri-information-line me-1"></i>
                                Fields marked with{" "}
                                <span className="text-danger">*</span> are
                                required.
                              </div>

                              <div className="d-flex gap-2">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                                  onClick={() => navigate(-1)}
                                  disabled={loading}
                                >
                                  <i className="ri-close-line"></i>
                                  Cancel
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-primary px-4 d-inline-flex align-items-center justify-content-center gap-2"
                                  disabled={loading}
                                >
                                  {loading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span>Submitting...</span>
                                    </>
                                  ) : (
                                    <>
                                      <i className="ri-save-line"></i>
                                      <span>Save Source</span>
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <Footer />

                  <div className="content-backdrop fade"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
};

export default AddMarketingSchool;
